export function isAgoWidgetExisting() {
  return document.querySelector('script[src="https://useago.github.io/widgetjs/frame.js"]');
}

export function initAgoWidget() {
  const agoScript = document.createElement('script');
  agoScript.setAttribute('src', 'https://useago.github.io/widgetjs/frame.js');
  document.head.appendChild(agoScript);
}

export function hideAgoWidget() {
  const agoWidget = document.getElementById('ago-wrapper');
  agoWidget.style.display = 'none';
}

export function showAgoWidget() {
  const agoWidget = document.getElementById('ago-wrapper');
  agoWidget.style.display = 'block';
}



// WEBPACK FOOTER //
// ./src/plugins/ago.js